import router from '..'

export default function rbac () {
  const role = localStorage.getItem('role')
  if (role !== '1' && role !== '2') {
    router.push({ name: 'UnauthorizedView' })
  }
  return true
}
